module.exports = __webpack_public_path__ + "1372de09cfc3e9a62af4234fd331e8e9.woff";